import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import { CircularProgress, Fade } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { validateSignInData } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import AppBar from '@material-ui/core/AppBar';
import { Redirect, withRouter } from 'react-router-dom';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants';
import SocialSignin from '../../components/Social/SocialSignin';
import { cookies } from '../../utils/getToken';
import { FormattedMessage, injectIntl } from 'react-intl';
import AppLinks from '../../components/About/AppLinks';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CustomerVerification from '../../components/Customer/CustomerVerification';
import Verification from '../../components/Providers/Verification';
import ForgotPassword from './ForgotPassword';

class SigninForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            email: '',
            password: '',
            showCustomerVerification: false,
            showProviderVerification: false,
            closeVerification: false,
            playerId: '',
            showForgotPopup: false,
            samePage: false,
            role: '',
            customerRedirect: false,
            providerRedirect: false,
            value: 0
        };
        // this.props = {
        //     renderSamePage: props.renderSamePage ? props.renderSamePage : false,
        //     renderUrl: props.renderUrl
        // };
    }

    handleClose = () => {
        this.props.closeLoginPopup();
    };
    handleChange = (event, value) => {
        this.setState({ value });
    };

    renderLoginButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.loginActionCall()}
                >
                    <FormattedMessage id="login" defaultMessage="Login" />
                </Button>
            );
        }
    };

    loginActionCall = async () => {
        if (
            validateSignInData(
                { email: this.state.email, password: this.state.password },
                this.handleError
            )
        ) {
            this.setState({ loaderButton: true });
            this.props.loginAction(
                {
                    email: this.state.email,
                    password: this.state.password
                },
                this.onDone
            );
        } else {
            NotificationManager.error('Validation Error', 'Oops!');
        }
    };
    handleError = params => {
        this.setState(params);
    };
    renderProviderVerification = email => {
        this.setState({ showProviderVerification: true, usedEmail: email });
    };
    renderCustomerVerification = email => {
        this.setState({ showCustomerVerification: true, usedEmail: email });
    };
    renderForgotPassword = (email,role) => {
        this.setState({ showForgotPopup: true, usedEmail: email,userRole:role });
    };

    // handleClose = () => {
    //     this.props.closeLoginPopup();
    // };
    onDone = (success, data) => {
        this.setState({
            role: data.role
        });

        if (success == 'NOV') {
            if (data.data.role == ROLE_CUSTOMER) {
                this.setState(
                    {
                        loaderButton: false
                    },
                    () => {
                        this.renderCustomerVerification(this.state.email);
                        //this.handleClose();
                    }
                );
            } else if (data.data.role == ROLE_PROVIDER) {
                this.setState(
                    {
                        loaderButton: false,
                        showProviderVerification: true
                    },
                    () => {
                        this.renderProviderVerification(this.state.email);
                        //this.handleClose();
                    }
                );
            }
        } else if (success == true) {
            if (!cookies.get('x-auth-token', { path: '/' })) {
                cookies.set('x-auth-token', data.token, { path: '/' });
            }
            if (!this.props.renderSamePage) {
                if (this.state.role == ROLE_CUSTOMER) {
                    this.setState({
                        loaderButton: false,
                        customerRedirect: true
                    });
                } else {
                    this.setState({
                        loaderButton: false,
                        providerRedirect: true
                    });
                }
            } else {
                this.setState({
                    loaderButton: false,
                    samePage: true
                });
            }
        } else {
            this.setState({
                loaderButton: false,
                emailError: data.message
            });
        }
    };
    renderSignupPage = () => {
        this.props.history.push({ pathname: `/signup` });
    };
    handleForgotClose = () => {
        this.setState({ showForgotPopup: false });
    };
    render() {
        const { passwordError, emailError } = this.state;
        const { formatMessage } = this.props.intl;        
        const { value } = this.state;
        if (this.state.customerRedirect) {
            // this.handleClose();
            // this.props.history.push({ pathname: `/user/profile` });
            return <Redirect to={'/user/profile'} />;
        }
        if (this.state.providerRedirect) {
            this.props.history.push(`/user/dashboard`);
            //this.handleClose();
        }
        if (this.state.samePage) {
            // this.handleClose();
            this.props.history.push({ pathname: this.props.renderUrl });
            // return <Redirect to={this.props.renderUrl} />;
        }
        return (
            <div>
                <div className="tz-register">
                    <div className="log-in-pop">
                        <div className="log-in-pop-left">
                            <h1>
                                Hello... <span className="ng-binding" />
                            </h1>
                            <p>
                                Don’t have an account? Create your own account.
                                It takes only few minutes.
                            </p>
                            {value === 0 && (
                                <React.Fragment>
                                    <h4>Login with social media</h4>

                                    <SocialSignin
                                        // loginDone={this.handleClose}
                                        isLoginScreenCall={false}
                                        className="dark"
                                    />
                                </React.Fragment>
                            )}
                        </div>
                        <div className="log-in-pop-right">
                            <a
                                href="#"
                                className="pop-close"
                                data-dismiss="modal"
                            />
                            <h4>Login</h4>
                            <p>
                                Don’t have an account? Create your own account.
                                It takes only few minutes.
                            </p>
                            <div className="s12 ng-pristine ng-valid">
                                <div>
                                    <AppBar
                                        position="static"
                                        color="default"
                                        className="create-account-nav"
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={this.handleChange}
                                            variant="scrollable"
                                            scrollButtons="on"
                                            indicatorColor="primary"
                                            textColor="primary"
                                            centered
                                        >
                                            <Tab
                                                className="btn-tab-account"
                                                label={formatMessage({
                                                    id: 'customer'
                                                })}
                                            />
                                            <Tab
                                                className="btn-tab-account"
                                                label={formatMessage({
                                                    id: 'Provider'
                                                })}
                                            />
                                        </Tabs>
                                    </AppBar>
                                    {value === 0 && (
                                        <form
                                            className="s12 ng-pristine ng-valid form-new"
                                            autoComplete="off"
                                        >
                                            <div
                                                className="dialog-header"
                                                style={{
                                                    backgroundColor: this.props
                                                        .theme.palette.primary
                                                        .main
                                                }}
                                            />
                                            <div className="dialog-body">
                                                <div className="input-field s12">
                                                    <TextField
                                                        error={
                                                            emailError
                                                                ? true
                                                                : false
                                                        }
                                                        helperText={emailError}
                                                        className="login-form-textfield"
                                                        id="email"
                                                        fullWidth={true}
                                                        name="email"
                                                        label={formatMessage({
                                                            id: 'email'
                                                        })}
                                                        type="email"
                                                        value={this.state.email}
                                                        onChange={event => {
                                                            this.setState({
                                                                email:
                                                                    event.target
                                                                        .value,
                                                                emailError: ''
                                                            });
                                                        }}
                                                        disabled={
                                                            this.state
                                                                .loaderButton
                                                        }
                                                        margin={'normal'}
                                                        title="Enter your email"
                                                    />
                                                </div>
                                                <div className="input-field s12">
                                                    <TextField
                                                        error={
                                                            passwordError
                                                                ? true
                                                                : false
                                                        }
                                                        helperText={
                                                            passwordError
                                                        }
                                                        className="login-form-textfield"
                                                        id="password"
                                                        fullWidth={true}
                                                        name="password"
                                                        type="password"
                                                        label={formatMessage({
                                                            id: 'password'
                                                        })}
                                                        value={
                                                            this.state.password
                                                        }
                                                        onChange={event => {
                                                            this.setState({
                                                                password:
                                                                    event.target
                                                                        .value,
                                                                passwordError:
                                                                    ''
                                                            });
                                                        }}
                                                        disabled={
                                                            this.state
                                                                .loaderButton
                                                        }
                                                        margin={'normal'}
                                                        title="Enter your password"
                                                    />
                                                </div>

                                                <div className="input-field s12">
                                                    <p>
                                                        {' '}
                                                        <a
                                                            style={{
                                                                cursor:
                                                                    'pointer',
                                                                color: this
                                                                    .props.theme
                                                                    .palette
                                                                    .primary
                                                                    .main
                                                            }}
                                                            onClick={() =>
                                                                this.renderForgotPassword(
                                                                    this.state
                                                                        .email,ROLE_CUSTOMER
                                                                )
                                                            }
                                                        >
                                                            <FormattedMessage
                                                                id="forgotPassword"
                                                                defaultMessage="Forgot Password?"
                                                            />
                                                        </a>
                                                    </p>
                                                </div>

                                                <div className="sign-new-btn text-left">
                                                    {this.renderLoginButton()}
                                                </div>
                                            </div>
                                            <div>
                                                <div className="input-field s12">
                                                    <a href="javascript:void(0);">
                                                        Not a member yet?
                                                        <p
                                                            onClick={
                                                                this
                                                                    .renderSignupPage
                                                            }
                                                        >
                                                            Signup Now
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                    {value === 1 && (
                                        <form
                                            className="s12 ng-pristine ng-valid form-new"
                                            autoComplete="off"
                                        >
                                            <div
                                                className="dialog-header"
                                                style={{
                                                    backgroundColor: this.props
                                                        .theme.palette.primary
                                                        .main
                                                }}
                                            />
                                            <div className="dialog-body">
                                                <div className="input-field s12">
                                                    <TextField
                                                        error={
                                                            emailError
                                                                ? true
                                                                : false
                                                        }
                                                        helperText={emailError}
                                                        className="login-form-textfield"
                                                        id="email"
                                                        fullWidth={true}
                                                        name="email"
                                                        label={formatMessage({
                                                            id: 'email'
                                                        })}
                                                        type="email"
                                                        value={this.state.email}
                                                        onChange={event => {
                                                            this.setState({
                                                                email:
                                                                    event.target
                                                                        .value,
                                                                emailError: ''
                                                            });
                                                        }}
                                                        disabled={
                                                            this.state
                                                                .loaderButton
                                                        }
                                                        margin={'normal'}
                                                        title="Enter your email"
                                                    />
                                                </div>
                                                <div className="input-field s12">
                                                    <TextField
                                                        error={
                                                            passwordError
                                                                ? true
                                                                : false
                                                        }
                                                        helperText={
                                                            passwordError
                                                        }
                                                        className="login-form-textfield"
                                                        id="password"
                                                        fullWidth={true}
                                                        name="password"
                                                        type="password"
                                                        label={formatMessage({
                                                            id: 'password'
                                                        })}
                                                        value={
                                                            this.state.password
                                                        }
                                                        onChange={event => {
                                                            this.setState({
                                                                password:
                                                                    event.target
                                                                        .value,
                                                                passwordError:
                                                                    ''
                                                            });
                                                        }}
                                                        disabled={
                                                            this.state
                                                                .loaderButton
                                                        }
                                                        margin={'normal'}
                                                        title="Enter your password"
                                                    />
                                                </div>

                                                <div className="input-field s12">
                                                    <p>
                                                        {' '}
                                                        <a
                                                            style={{
                                                                cursor:
                                                                    'pointer',
                                                                color: this
                                                                    .props.theme
                                                                    .palette
                                                                    .primary
                                                                    .main
                                                            }}
                                                            onClick={() =>
                                                                this.renderForgotPassword(
                                                                    this.state
                                                                        .email,ROLE_PROVIDER
                                                                )
                                                            }
                                                        >
                                                            <FormattedMessage
                                                                id="forgotPassword"
                                                                defaultMessage="Forgot Password?"
                                                            />
                                                        </a>
                                                    </p>
                                                </div>

                                                <div className="sign-new-btn text-left">
                                                    {this.renderLoginButton()}
                                                </div>
                                            </div>
                                            <div>
                                                <div className="input-field s12">
                                                    <a href="javascript:void(0);">
                                                        Not a member yet ?
                                                        <p
                                                            onClick={
                                                                this
                                                                    .renderSignupPage
                                                            }
                                                        >
                                                            Signup Now
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AppLinks settings={this.props.settings} />

                <CustomerVerification
                    email={this.state.usedEmail}
                    open={this.state.showCustomerVerification}
                    closePopup={this.handleCustomClose}
                />
                <Verification
                    email={this.state.usedEmail}
                    open={this.state.showProviderVerification}
                    close={this.handleVerifyClose}
                />
                <ForgotPassword
                    email={this.state.usedEmail}
                    role={this.state.userRole}
                    open={this.state.showForgotPopup}
                    close={this.handleForgotClose}
                />
            </div>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return { settings };
};
const composedHOC = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedHOC(injectIntl(SigninForm));



// WEBPACK FOOTER //
// ./src/views/LoginPage/SigninForm.jsx